import React from "react";

/**
 * @param {"page" | "modal"} [variant="page"]
 * - "page": full viewport, centered (for whole-page loading)
 * - "modal": fills parent height/width, centered (for modal content loading)
 */
const Loading = ({ variant = "page" }) => {
  const isPage = variant === "page";

  return (
    <div
      className={
        isPage
          ? "fixed inset-0 z-40 flex justify-center items-center w-full min-h-screen bg-white/80"
          : "flex justify-center items-center"
      }
      role="status"
      aria-label="Loading">
      <div
        className={`animate-spin rounded-full border-t-4 border-red-500 ${
          isPage ? "h-16 w-16" : "h-12 w-12"
        }`}
      />
    </div>
  );
};

export default Loading;
